import i18n from '../../i18n';

export const isNotEmpty = (value) => {
  return value !== null && value !== undefined && value.trim() !== '';
};

export const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

export const getSecondsAsMinAndSecString = (timeDurationSeconds) => {
  const minutes = Math.floor(timeDurationSeconds / 60);
  const seconds = timeDurationSeconds % 60;
  return `${minutes > 0 ? `${minutes} ${i18n.t('common.minutes')}` : ``} ${
    seconds < 10 ? '0' + seconds : seconds
  } ${i18n.t('common.seconds')}`;
};